import moment from "moment";
import { ReactNode } from "react";

type Props = {
  title: string;
  value: string | ReactNode;
  type?: "Date";
};
export const Row = ({ title, value, type }: Props) => {
  if (type === "Date")
    value =
      value && typeof value === "string"
        ? moment(value).format("MMM DD, YYYY")
        : value;

  return (
    <div className="flex gap-2 text-sm font-medium">
      <p className="min-w-[100px] text-content-300">{title}</p>
      <p className="text-content-1000">{value || "-"}</p>
    </div>
  );
};
